import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Entra ID authentication.
 * The clientId and authority must match the Entra ID app registration created by Pulumi.
 * Set REACT_APP_MSAL_CLIENT_ID and REACT_APP_MSAL_AUTHORITY in .env.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    authority: process.env.REACT_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin, // Redirect to origin, then handle state-based redirect
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes required for admin API calls.
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Scopes for calling the Function App API (if using token-based auth).
 */
export const apiRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE || 'api://default/.default'],
};
